import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getWhatsAppFlowListSGCacheKey } from "./constants";
import type { WhatsAppListFlowsResponse } from "./types";

export const getWhatsAppFlowListBySubscriptionGroup = reactQueryFetcherAdapter(
  getWhatsAppFlowListSGCacheKey,
  async (signal, appGroupId: string, subscriptionGroupId: string): Promise<WhatsAppListFlowsResponse> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/flows/sg/${subscriptionGroupId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
